import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, parseClasses } from '../../lib/ep.js';

import ActionLink from './ActionLink';

const FieldLabel = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const force_display = props?.force_display ?? false;
	const empty_label = props?.empty_label ?? false;

	const autotranslate = props?.autotranslate ?? true;
	let input_label = null;
	if(props.children != undefined && props.children != '' && props.children != ' ') {
		if(autotranslate) {
			const _input_label = props.intl.formatMessage({id:props.children});
			input_label = (typeof(_input_label) == 'string') ? _input_label.replace("***", "") : _input_label;
		} else {
			input_label = props.children;
		}
	}

	if(!force_display && input_label == null) return null;

	const edit_url = props?.edit_url ?? false;
	const edit_url_target = props?.edit_url_target ?? '_self';

	const extra_contents = props?.extra_contents ?? false;
	const extra_contents_whole = props?.extra_contents_whole ?? false;

	let extra_msg = false;
	let extra_link_text = false;
	let extra_link_url = false;
	let extra_msg_autotranslate = true;
	let extra_classes = [];
	let extra_styles = false;
	
	if(props.addition != undefined) {
		extra_classes = ['label_additional_msg', 'in_label'];
		extra_classes.push((extra_contents_whole) ? 'whole_contents' : 'sided_contents');
		if(props.extra_classes != undefined) extra_classes.push(props.extra_classes);

		if(typeof props.addition == 'object') {
			extra_msg = props?.addition.text ?? '';
			if(props.addition.link_text != undefined) extra_link_text = props.addition.link_text;
			if(props.addition.link_url != undefined) extra_link_url = props.addition.link_url;
			if(props.addition.autotranslate != undefined) extra_msg_autotranslate = props.addition.autotranslate;
			if(props.addition.classes != undefined) extra_classes.push(props.addition.classes);
			if(props.addition.styles != undefined) extra_styles = props.addition.styles;
		} else {
			extra_msg = props.addition;
		}

		extra_msg = extra_msg + '';
	}

	const extra_component = props?._extra_component ?? false;
	const is_mandatory = props?.mandatory ?? false;

	let classname = props?.classname ?? '';
	classname = parseClasses(classname, props._class);

	let has_colon = props?.with_colon ?? true;

	if(typeof(input_label) == 'string') {
		const last_char = input_label.substring(input_label.length - 1, input_label.length);

		if(last_char == '?' || last_char == '!' || last_char == '.') {
			has_colon = false;
		}
	}

	if(!has_colon) classname += ' without_colon';

	if(empty_label) {
		return (
			<label for={props.name} class={classname} style={props.style}>&nbsp;</label>
		)
	}

	return (
		<label for={props.name} class={classname} style={props.style}>
			{(typeof input_label === 'object') ? (
				<span class="in_label">{props?.pre ?? ""}{input_label}</span>
			) : (
				<span class="in_label" dangerouslySetInnerHTML={{ __html:`${props?.pre ?? ""}${input_label}` }} />
			)}

			{(is_mandatory) && (
				<span class="is_mandatory_icon"><span /></span>
			)}

			{(edit_url) && (
				<span class="edit_link">(<ActionLink _href={edit_url} target={edit_url_target}>Edit</ActionLink>)</span>
			)}

			{(extra_msg !== false && extra_msg != '') && (
				<span class={extra_classes.join(" ")} style={(extra_styles !== false) ? extra_styles : null}>
					{(extra_msg != '' && extra_msg != 0) && (
						<span>{(extra_msg_autotranslate) ? i18n(extra_msg) : extra_msg}</span>
					)}
					{(extra_link_url && extra_link_text) && (
						<a href={extra_link_url} class="extra_link" target="_blank">{i18n(extra_link_text)}</a>
					)}
				</span>
			)}

			{(extra_component !== false) && (
				<span class={'label_additional_msg in_label '+((extra_contents_whole) ? 'whole_contents' : 'sided_contents')}>{extra_component}</span>
			)}

			{(props.tooltip != undefined) && (
				props.tooltip
			)}

			{(extra_contents !== false) && (
				<span class={'label_additional_msg in_label '+((extra_contents_whole) ? 'whole_contents' : 'sided_contents')}>{extra_contents}</span>
			)}
		</label>
	);
}

export default injectIntl(FieldLabel);